import type { Schema } from "yup";
import { array, object, string } from "yup";

import { translate } from "utils/translations/translate";

const vulnTypeSchema = (suggestions: string[]): Schema =>
  string()
    .required(translate.t("validations.required"))
    .isValidFunction((value?: string): boolean => {
      if (value === undefined || value === "") {
        return false;
      }
      const textMatch = /^\d{3}\. .+/gu.exec(value);

      return suggestions.includes(value) && textMatch !== null;
    }, translate.t("validations.draftTypology"));

const validations = (isAccepted: boolean, suggestions: string[]): Schema =>
  object().shape({
    type: string().when([], (): Schema => {
      return isAccepted ? string().nullable() : vulnTypeSchema(suggestions);
    }),
    typeOptions: array().when([], (): Schema => {
      return isAccepted
        ? array().of(vulnTypeSchema(suggestions))
        : array().notRequired();
    }),
  });

export { validations };
